import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CardComponent } from '@tnq/shared/ui';

/** Container/header/card box model for "single card, centered on the page" screens; content is projected in. */
@Component({
  selector: 'tnq-centered-card-layout',
  imports: [CardComponent],
  templateUrl: './centered-card-layout.component.html',
  styleUrl: './centered-card-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CenteredCardLayoutComponent {
  readonly header = input<string>();
}
